export default "__VITE_ASSET__17357905__"